import React from 'react';
import ReactDOM from 'react-dom/client';
import "./index.css";
import './custom.scss';

import { RouterProvider } from 'react-router-dom';

import router from './settings/Router'

import 'bootstrap/dist/css/bootstrap.min.css';
import { RecoilRoot } from 'recoil';

import { PinDataProvider } from './data/PinDataContext';
import { MediaDataProvider } from './data/MediaDataContext';
ReactDOM.createRoot(document.getElementById("root")).render(
  <RecoilRoot>
    <React.StrictMode>
      <PinDataProvider>
        <MediaDataProvider>
          <RouterProvider router={router} />
        </MediaDataProvider>
      </PinDataProvider>
    </React.StrictMode>
  </RecoilRoot>
);
